export default __webpack_public_path__ + "static/media/card5.7ed4b521.jpg";